/*  PROPS CONTROLLER:

    - show
    - title
    - text
    - showInput
    - inputLabel
    - showButtons
    - confirmFunction
    - confirmButtonText
    - cancelFunction
    - cancelButtonText
    - onClose
*/

import { useContext } from 'react';

// STYLE
import styles from './css/boxAlert.module.css';

// ICONS
import { IoMdCloseCircle } from 'react-icons/io';


export default function BoxAlert(props) {

    return (
        <>
            {props.show ? (
                <div className={styles.alertComponent}>
                    <div className={styles.overlayCart}></div>

                    <div className={styles.alertBox}>
                        {props.showCloseButton ? (
                            <button className={styles.closeDataRequest} onClick={() => props.onClose()}>
                                <IoMdCloseCircle size={25} color="#333" />
                            </button>
                        ) : null}

                        <h1 className={styles.titleAlertBox} style={{ marginBottom: 0 }}>
                            {props.title}
                        </h1>

                        {!props.body ? (
                            <>
                                {props.text && <p className={styles.textAlertBox} style={{paddingBottom: props.input ? 0 : 60}}>{props.text}</p>}

                                {props.input && (
                                    <div className={styles.inputRequestArea}>
                                        {props.inputLabel && <p className={styles.labelRequestData}>{props.inputLabel}</p>}
                                        {props.input}
                                    </div>
                                )}

                                {props.showButtons ? (
                                    <div className={styles.buttonsBoxArea}>
                                        <button className={[styles.buttonBoxConfig]} id={styles.leftBoxButton} onClick={() => props.cancelFunction ? props.cancelFunction() : props.onClose()}>
                                            <p className={styles.textAlertButton}>
                                                {props.cancelButtonText || 'Voltar'}
                                            </p>
                                        </button>
                                        <button className={styles.buttonBoxConfig} id={styles.rightBoxButton} onClick={() => props.confirmFunction()}>
                                            <p className={styles.textAlertButton}>
                                                {props.confirmButtonText || 'Prosseguir'}
                                            </p>
                                        </button>
                                    </div>

                                ) : (
                                    <button className={styles.proceedRequestDataBtn} onClick={() => props.confirmFunction ? props.confirmFunction() : props.onClose()}>
                                        <p className={styles.textAlertButton}>
                                            {props.confirmButtonText || 'Ok'}
                                        </p>
                                    </button>
                                )}
                            </>
                        
                        ) : (
                            <>
                                {props?.body}
                            </>
                        )}  

                    </div>
                </div>
            
            ) : null}
        </>
    );
}
